// extracted by mini-css-extract-plugin
export default {"cls1":"FocusedNav-cls1___d8d39936f08acf86cb1","cls2":"FocusedNav-cls2___21a6bdb54efdbc4676b FocusedNav-cls1___d8d39936f08acf86cb1"};